import { render } from "./show_achievement.vue?vue&type=template&id=8afbf942&scoped=true"
import script from "./show_achievement.vue?vue&type=script&lang=js"
export * from "./show_achievement.vue?vue&type=script&lang=js"

import "./show_achievement.vue?vue&type=style&index=0&id=8afbf942&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\yuanxi\\yuanxi-zju\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8afbf942"]])

export default __exports__